export const CREATE_ROLE_STEPS = [
  {
    icon: 'settings',
    id: 'creation-type',
    label: 'Creation Type'
  },
  {
    icon: 'edit',
    id: 'details',
    label: 'Details'
  }
];

export const STEP_IDS = {
  CREATION_TYPE: 'creation-type',
  DETAILS: 'details'
};

